import { Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { ActivityMonitorTab } from '../../components';

type ActivityMonitorSearch = {
  advisoryOrganizationId?: string;
  jobStatus?: string;
  planId?: string;
  queueDateTimeFrom?: string;
  queueDateTimeTo?: string;
  taskTypeId?: string;
};

const ActivityMonitorPage = () => (
  <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
    <Typography variant='h5'>Activity Monitor</Typography>
    <ActivityMonitorTab mode='global' />
  </Stack>
);

export const Route = createFileRoute('/activity-monitor/')({
  component: ActivityMonitorPage,
  validateSearch: (search: Record<string, unknown>): ActivityMonitorSearch => ({
    advisoryOrganizationId:
      typeof search.advisoryOrganizationId === 'string'
        ? search.advisoryOrganizationId
        : undefined,
    jobStatus:
      typeof search.jobStatus === 'string' ? search.jobStatus : undefined,
    planId: typeof search.planId === 'string' ? search.planId : undefined,
    queueDateTimeFrom:
      typeof search.queueDateTimeFrom === 'string'
        ? search.queueDateTimeFrom
        : undefined,
    queueDateTimeTo:
      typeof search.queueDateTimeTo === 'string'
        ? search.queueDateTimeTo
        : undefined,
    taskTypeId:
      typeof search.taskTypeId === 'string' ? search.taskTypeId : undefined
  })
});
